import { render, staticRenderFns } from "./ProductNotesTooltip.vue?vue&type=template&id=d732da90&"
import script from "./ProductNotesTooltip.vue?vue&type=script&lang=js&"
export * from "./ProductNotesTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports